import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  return useMemo(() => {
    if (!rdata) return rdata
    let { assignees, patients, ...task } = rdata

    return {
      ...task,
      assignee: assignees[0],
      patient: patients[0],
    }
  }, [rdata])
}
